import { Show } from "solid-js";
import { Title } from "@solidjs/meta";
import { createPatientText, type PatientI18n, PatientTextProvider } from "~/patient_i18n/i18n";
import { PatientLanguageBar } from "~/patient_i18n/language_bar";
import { ContentRenderer } from "~/util/content_renderer";
import { PublicLocationCard } from "../_location_card";

type Props = {
  page: "terms" | "privacy";
  locationName: string;
  logoUrl: string | null;
  addressLines: string[] | null;
  phone: string | null;
  content: string;
  patientI18n: PatientI18n;
};

// Only the chrome follows the page's language. The policy itself is legal text, the office's own or
// Twelve's English default, so it stays as written and a line in the patient's language says so.
export function LegalPageLayout(props: Props) {
  // The language only changes on a full page load, so the strings are read once.
  // eslint-disable-next-line solid/reactivity
  const text = createPatientText(props.patientI18n);
  const t = text.t;
  const title = () => t(`legal_pages.${props.page}_title`);

  return (
    <PatientTextProvider value={text}>
      <Title>{t("legal_pages.page_title", { title: title(), name: props.locationName })}</Title>
      <PublicLocationCard
        locationName={props.locationName}
        logoUrl={props.logoUrl}
        addressLines={props.addressLines}
        phone={props.phone}
        maxWidth="4xl"
        toolbar={<PatientLanguageBar />}
      >
        <Show when={text.locale !== "en"}>
          <p class="mb-6 rounded-xl bg-brand-light px-4 py-3 text-sm text-typography-secondary">
            {t(`legal_pages.${props.page}_in_english`)}
          </p>
        </Show>
        <ContentRenderer content={props.content} trustedContent />
      </PublicLocationCard>
    </PatientTextProvider>
  );
}
